const DEVICE_ID_KEY = 'gfh_device_id';

let accessToken = '';

function randomId(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return `gfh-${Date.now()}-${Math.random().toString(36).slice(2, 12)}`;
}

export function getDeviceId(): string {
  try {
    const existing = sessionStorage.getItem(DEVICE_ID_KEY);
    if (existing) {
      return existing;
    }
    const created = randomId();
    sessionStorage.setItem(DEVICE_ID_KEY, created);
    return created;
  } catch {
    return randomId();
  }
}

export function getAccessToken(): string {
  return accessToken;
}

export function setAccessToken(token: string): void {
  accessToken = token?.trim() || '';
}

export function clearAccessToken(): void {
  accessToken = '';
}

export function getApiAuthHeaders(extra: Record<string, string> = {}): Record<string, string> {
  const headers: Record<string, string> = {
    ...extra,
    'X-GFH-Device-Id': getDeviceId(),
  };
  if (accessToken) {
    headers['Authorization'] = `Bearer ${accessToken}`;
  }
  return headers;
}

export function appendWsAuth(url: string): string {
  const parsed = new URL(url, typeof window !== 'undefined' ? window.location.origin : 'http://localhost');
  parsed.searchParams.set('device_id', getDeviceId());
  if (accessToken) {
    parsed.searchParams.set('access_token', accessToken);
  }
  return parsed.toString();
}
